export const proSkills = [
  {
    title: 'Software Architecture & Design Patterns',
    text: 'End-to-end system design, microservices decomposition, high-level diagramming, and enforcing clean, maintainable code structures. ',
  },
  {
    title: 'Technical Leadership & Mentoring',
    text: 'Merge-request/code reviews, task delegation, guiding distributed squads, and making high-impact technical decisions.',
  },
  {
    title: 'Agile Project Management',
    text: 'Large-scale estimations, sprint planning, budget forecasting, and continuous delivery in Agile environments.',
  },
  {
    title: 'Testing & Quality Assurance',
    text: 'Test-driven development, regression testing, documentation, and maintaining CI pipelines for reliable releases.',
  },
  {
    title: 'UI/UX & Product Thinking',
    text: 'Responsive web design, Figma prototyping, and translating business requirements into intuitive user experiences.',
  },
  {
    title: 'Soft-Skill Enablers',
    text: 'Clear client communication, problem solving, creativity, strong organizational habits, self-motivation, and team leadership.',
  },
];
